import React from "react";
import { AuthenticationState, AzureAD, IAzureADFunctionProps } from "react-aad-msal";
import { useStore, useSelector, useDispatch } from "react-redux";
import { authProvider } from "./authProvider";
import { authStatusSelector, userSelector } from "../common/redux/selectors";
import { TermsConditions } from "./presentation/TermsConditions";
import { ACCEPT_TERMS } from "../common/redux/actions";
import { Button, Container, Divider, Typography } from "@material-ui/core";

export const Component: React.FC = (props) => {
  const store = useStore();
  const dispatch = useDispatch();
  const authStatus = useSelector(authStatusSelector);
  const user = useSelector(userSelector);

  const acceptedTerms = user?.acceptedTerms;
  const acceptTerms = () => {
    dispatch({ type: ACCEPT_TERMS });
  };

  return (
    <React.Fragment>
      <AzureAD provider={authProvider} reduxStore={store} forceLogin={true}>
        {
          ({login, logout, authenticationState, error, accountInfo} : IAzureADFunctionProps) => {
            switch (authenticationState) {
              case AuthenticationState.Authenticated:
                return (
                  <>
                    {authStatus === "LOGGED_IN" ? props.children : <></>}
                    <TermsConditions show={!!user && !acceptedTerms} acceptTerms={acceptTerms} />
                  </>
                );
              case AuthenticationState.InProgress:
                return (
                  <></>
                );
              default:
                return (
                  <>
                    <Container maxWidth="md" style={{ padding: 50 }}>
                      <Typography variant="body1">Login failed</Typography>
                      <Typography variant="body1">Please ensure you are logging in with your Ofqual (@ofqual.uk or @ofqual.gov.uk) account details</Typography>
                      <Button variant="outlined" onClick={() => {
                        logout();
                        login();
                      }}>Log out</Button>
                      <br />
                      <Divider />
                      <Typography variant="body1">Detailed error information: {error?.errorCode} {error?.errorMessage}</Typography>
                    </Container>
                  </>
                )
            }
          }
        }
      </AzureAD>
    </React.Fragment>
  );
};

// old:

// {/* Authentication is two steps (we hit users api after successful AD login) but
//       AzureAD Component does not know about the second stage, so protect the content
//       with a further `isAuthed` check  */}
//       {authStatus === "LOGGED_IN" ? props.children : <></>}
//       <TermsConditions show={!!user && !acceptedTerms} acceptTerms={acceptTerms} />
//     </AzureAD>
//     {authStatus === "LOGGING_IN" && (
//       // we could show some content here if appropriate
//       <React.Fragment />
//     )}
//     {authStatus === "NOT_LOGGED_IN" && (
//       <React.Fragment>Not logged in...</React.Fragment>
//     )}
